import '../../static/css/home/footer.css';
import {
    ThinAdminIcon,
    ThinCallIcon,
    ThinLocationIcon,
    ThinMailIcon,
    ThinnerPeopleIcon,
    ThinTaskIcon
} from "../icons/material-icons";
import {Link} from "react-router-dom";

export const HomeFooter = (props: { signup: boolean }) => {
    return (
        <footer>
            <div className="container-big">
                <div className="row" style={{paddingBottom: 20}}>
                    <div className="col-lg-5">
                        <div className="footer-about">
                            <div className="footer-about-logo">
                                <img src="/logo.png" alt="نهال"/>
                                <div>
                                    <b>نهال</b>
                                    <span>دبستان هوشمند و مهارتی دخترانه</span>
                                </div>
                            </div>
                            <p>مدرسه نهال اولین دبستان دخترانه با رویکرد مهارتی می‌باشد که واقع در شهرستان کاشمر
                                می‌باشد. ما در دبستان نهال امید داریم که بتوانیم با ایجاد یک فضای مناسب و آموزش صحیح سهم
                                مهمی در تربیت دانش‌آموزانمان داشته باشیم.</p>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="footer-contact">
                            <b>روش های ارتباطی با نهال</b>
                            <div>
                                <ThinCallIcon/>
                                <div>
                                    <span>تلفن تماس:</span>
                                    <b>۰۵۱-۵۵۲۵۹۲۰۲</b>
                                    <b>۰۹۱۵۱۳۶۶۴۴۰</b>
                                </div>
                            </div>
                            <div>
                                <ThinMailIcon/>
                                <div>
                                    <span>پست الکترونیک:</span>
                                    <b>info@nahalmaharat.ir</b>
                                </div>
                            </div>
                            <div>
                                <ThinLocationIcon/>
                                <div>
                                    <span>نشانی:</span>
                                    <b>کاشمر، جنب جهاد دانشگاهی، دبستان دخترانه نهال</b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="footer-links">
                            <b>بخش های کاربری</b>
                            <Link to="/students">
                                <ThinnerPeopleIcon/>
                                پنل دانش‌آموزان
                            </Link>
                            <Link to="/admins">
                                <ThinAdminIcon/>
                                پنل کادر اداری
                            </Link>
                            {/*<Link to="/hr">*/}
                            {/*    <ThinBadgeIcon/>*/}
                            {/*    پنل دبیران*/}
                            {/*</Link>*/}
                            {
                                props.signup ?
                                    <Link to="/signup">
                                        <ThinTaskIcon/>
                                        پیش ثبت‌نام
                                    </Link> : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-copyright">
                <p>تمام حقوق برای دبستان دخترانه نهال محفوظ است.</p>
                <div>
                    توسعه و پشتیبانی
                    <a href="https://www.tclass.ir" target="_blank" rel="noreferrer">
                        <i style={{backgroundImage: 'url(https://tstatic.ir/branding/tclass/100x100)'}}/>
                        تیکلاس
                    </a>
                </div>
            </div>
        </footer>
    );
};